import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import H3FormInput from '@Uilib/h3FormInput';
import CategoryActions from '@Actions/categoryActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';

const CategoryForm = ({
  createCategoryLoading,
  updateCategoryLoading,
  createCategory,
  updateCategory,
  selectedCategory,
  callback,
  history,
  user,
  createChildCategory,
  createSubCategory,
  createSubCategoryLoading,
}) => {
  const [productCategoryName, setProductCategoryName] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [ChildCategoryName, setChildCategoryName] = useState('');

  useEffect(() => {
    if (selectedCategory || createChildCategory) {
      setProductCategoryName(selectedCategory?.product_category_name || createChildCategory?.product_category_name || '');
    }
  }, [selectedCategory, createChildCategory]);

  const addCategory = () => {
    setFormSubmitted(true);

    if (!productCategoryName) return;

    const payload = {
      org_id: user?.tenant_info?.org_id,
      product_category_name: productCategoryName,
    };

    if (selectedCategory) {
      payload.product_category_id = selectedCategory?.product_category_id;

      updateCategory(payload, (createdCategory) => {
        if (callback) callback(createdCategory);
        else history.push('/admin/org?key=1');
      });
    } else {
      createCategory(payload, (createdCategory) => {
        if (callback) callback(createdCategory);
        else history.push('/admin/org?key=1');
      });
    }
  };

  const createChildCategoryApi = () => {
    setFormSubmitted(true);

    if (!productCategoryName || !ChildCategoryName) return;

    const payload = {
      product_category_name: ChildCategoryName,
      parent_product_category_id: createChildCategory?.product_category_id,
    };

    createSubCategory(payload, (createdCategory) => {
      if (callback) callback(createdCategory);
      else history.push('/admin/org?key=1');
    });
  };

  return (
    <Fragment>
      <div className="ant-row">
        <div className="ant-col-md-24">
          <H3FormInput
            name={createChildCategory ? 'Parent category name' : 'Category name'}
            type="text"
            containerClassName="orgInputContainer create-category-input"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => setProductCategoryName(event.target.value)}
            value={productCategoryName}
            label={createChildCategory ? 'Parent category name' : 'Category name'}
            maxLength="100"
            required
            showError={formSubmitted && !productCategoryName}
            disabled={createCategoryLoading || updateCategoryLoading || createChildCategory}
          />
        </div>
        { createChildCategory && (
          <div className="ant-col-md-24">
            <H3FormInput
              name="Child category name"
              type="text"
              containerClassName="orgInputContainer create-category-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setChildCategoryName(event.target.value)}
              value={ChildCategoryName}
              label="Child category name"
              maxLength="100"
              required
              showError={formSubmitted && !ChildCategoryName}
              disabled={createCategoryLoading || updateCategoryLoading || createSubCategoryLoading}
            />
          </div>
        )}
      </div>
      <div className="custom-drawer__footer">
        <div className="ant-col-md-6">
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text={selectedCategory ? 'Update Category' : 'Add Category'}
            onClick={createChildCategory ? createChildCategoryApi : addCategory}
            isLoading={createCategoryLoading || updateCategoryLoading || createSubCategoryLoading}
            disabled={createCategoryLoading || updateCategoryLoading || createSubCategoryLoading}
            style={{
              width: '160px',
              borderRadius: '5px',
              padding: '7px 0px',
              marginLeft: '0',
            }}
          />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, CategoryReducers }) => ({
  user: UserReducers.user,
  createCategoryLoading: CategoryReducers.createCategoryLoading,
  updateCategoryLoading: CategoryReducers.updateCategoryLoading,
  createSubCategoryLoading: CategoryReducers.createSubCategoryLoading,
  subCategories: CategoryReducers.subCategories,
});

const mapDispatchToProps = (dispatch) => ({
  createCategory: (payload, callback) => dispatch(CategoryActions.createCategory(payload, callback)),
  updateCategory: (payload, callback) => dispatch(CategoryActions.updateCategory(payload, callback)),
  createSubCategory: (payload, callback) => dispatch(CategoryActions.createSubCategory(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CategoryForm));
